import axios from '@/libs/api.request';

export const inspectorUserSave = data => {
    return axios.request({
        url: 'api/accountManagement/inspectorUserManagement/inspectorUserSave',
        data: data,
        method: 'post'
    });
};

export const getInspectorUserDetail = data => {
    return axios.request({
        url: 'api/accountManagement/inspectorUserManagement/getInspectorUserDetail',
        data: data,
        method: 'post'
    });
};

export const getInspectorUserList = data => {
    return axios.request({
        url: 'api/accountManagement/inspectorUserManagement/getInspectorUserList',
        data: data,
        method: 'post'
    });
};

export const getRoleList = data => {
    return axios.request({
        url: 'api/accountManagement/roleManagement/getRoleList',
        data: data,
        method: 'post'
    });
};

export const getRoleDetail = data => {
    return axios.request({
        url: 'api/accountManagement/roleManagement/getRoleDetail',
        data: data,
        method: 'post'
    });
};

export const roleSave = data => {
    return axios.request({
        url: 'api/accountManagement/roleManagement/roleSave',
        data: data,
        method: 'post'
    });
};

export const getRoleSeedFarmList = data => {
    return axios.request({
        url: 'api/accountManagement/roleSeedFarmManagement/getRoleSeedFarmList',
        data: data,
        method: 'post'
    });
};

export const batchAddRoleSeedFarm = data => {
    return axios.request({
        url: 'api/accountManagement/roleSeedFarmManagement/batchAddRoleSeedFarm',
        data: data,
        method: 'post'
    });
};

export const saveRoleSeedFarm = data => {
    return axios.request({
        url: 'api/accountManagement/roleSeedFarmManagement/saveRoleSeedFarm',
        data: data,
        method: 'post'
    });
};

export const getRoleProjectList = data => {
    return axios.request({
        url: 'api/accountManagement/roleProjectManagement/getRoleProjectList',
        data: data,
        method: 'post'
    });
};

export const batchAddRoleProject = data => {
    return axios.request({
        url: 'api/accountManagement/roleProjectManagement/batchAddRoleProject',
        data: data,
        method: 'post'
    });
};

export const saveRoleProject = data => {
    return axios.request({
        url: 'api/accountManagement/roleProjectManagement/saveRoleProject',
        data: data,
        method: 'post'
    });
};

export const getInspectorCompanyList = data => {
    return axios.request({
        url: 'api/accountManagement/projectManagement/getInspectorCompanyList',
        data: data,
        method: 'post'
    });
};

export const getInspectorDeptList = data => {
    return axios.request({
        url: 'api/accountManagement/projectManagement/getInspectorDeptList',
        data: data,
        method: 'post'
    });
};

export const getInspectorMemberList = data => {
    return axios.request({
        url: 'api/accountManagement/projectManagement/getInspectorMemberList',
        data: data,
        method: 'post'
    });
};

export const getCustomerMgrCompanyList = data => {
    return axios.request({
        url: 'api/accountManagement/projectManagement/getCustomerMgrCompanyList',
        data: data,
        method: 'post'
    });
};

export const getCustomerMgrDeptList = data => {
    return axios.request({
        url: 'api/accountManagement/projectManagement/getCustomerMgrDeptList',
        data: data,
        method: 'post'
    });
};

export const getCustomerMgrMemberList = data => {
    return axios.request({
        url: 'api/accountManagement/projectManagement/getCustomerMgrMemberList',
        data: data,
        method: 'post'
    });
};

export const getProjectList = data => {
    return axios.request({
        url: 'api/accountManagement/projectManagement/getProjectList',
        data: data,
        method: 'post'
    });
};

export const addProject = data => {
    return axios.request({
        url: 'api/accountManagement/projectManagement/addProject',
        data: data,
        method: 'post'
    });
};

export const saveProject = data => {
    return axios.request({
        url: 'api/accountManagement/projectManagement/saveProject',
        data: data,
        method: 'post'
    });
};